import { isProd } from '../api/constants';

export const formatLocaleDateTime = (timestamp: string | number | Date) => {
  const isLocal = !isProd;

  const date =
    typeof timestamp === 'string' &&
    !timestamp.toUpperCase().includes('Z') &&
    !isLocal
      ? new Date(`${timestamp}Z`)
      : new Date(timestamp);

  const pacificDate = new Date(
    date.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' })
  );

  const formattedDate = pacificDate.toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit'
  });

  const formattedTime = pacificDate.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit'
  });

  return `${formattedDate} ${formattedTime}`;
};

export const formatTimeDelta = (startISO: string, endISO: string): string => {
  const startTimestamp = new Date(startISO).getTime();
  const endTimestamp = new Date(endISO).getTime();

  let delta = Math.abs(endTimestamp - startTimestamp) / 1000;

  const timeUnits = [
    { label: 'year', seconds: 31536000 },
    { label: 'month', seconds: 2592000 },
    { label: 'day', seconds: 86400 },
    { label: 'hour', seconds: 3600 },
    { label: 'minute', seconds: 60 },
    { label: 'second', seconds: 1 }
  ];

  const result: string[] = [];

  for (const unit of timeUnits) {
    if (delta >= unit.seconds) {
      const value = Math.floor(delta / unit.seconds);
      delta -= value * unit.seconds;
      result.push(`${value} ${unit.label}${value > 1 ? 's' : ''}`);
    }
  }

  return result.join(' ');
};
